module.exports = __webpack_public_path__ + "img/banner3.020fe171.png";